import React, { useMemo, useState } from 'react';
import { 
  Plus, 
  Send, 
  MessageSquare, 
  CheckCircle, 
  Clock, 
  User 
} from 'lucide-react';
import { useRetornoAsesor } from '../../../../config/unificacion';
import { formatearFechaCompleta } from '../../../../utils/utils';
import ContenidoEnriquecido from '../../../../components/ContenidoEnriquecido';

const PreguntasComponent = ({ 
  preguntas = [], 
  usuarioActual = null,
  isAdmin = false,
  onEnviarPregunta = null,
  onResponderPregunta = null,
}) => {
  const [nuevaPregunta, setNuevaPregunta] = useState('');
  const [mostrandoFormulario, setMostrandoFormulario] = useState(false);
  const [respondiendo, setRespondiendo] = useState(null);
  const [nuevaRespuesta, setNuevaRespuesta] = useState('');
  const {nombreAsesor} = useRetornoAsesor();

  const [formData, setFormData] = useState({
      contenidoEnriquecido: '',
    });

    // Filtrar preguntas por tutor
  const preguntasFiltradas = useMemo(() => {
    if(isAdmin){
      return preguntas;
    }

    if (!usuarioActual?.nombrewhatsapp) {
      return preguntas; // Si no hay usuario tutor, mostrar todas las preguntas
    }
    
    return preguntas.filter(pregunta => 
      pregunta.nombreTutor === usuarioActual.nombrewhatsapp
    );
  }, [preguntas, usuarioActual]);

  const handleEnviarPregunta = async () => {
    console.log(" a enviar pregunta");
    if (!onEnviarPregunta) return;

    try {
      console.log("1",formData.contenidoEnriquecido);

      const preguntaData = {  
        id: `pregunta-${Date.now().toString()}`, 
        pregunta : formData.contenidoEnriquecido,
        fechaPregunta: new Date(),
        nombreTutor  : usuarioActual.nombrewhatsapp,
      };

      console.log("pregunta data",preguntaData);

      const listaActualizada = [...preguntas, preguntaData];

      await onEnviarPregunta(listaActualizada);
      
      setNuevaPregunta('');
      setMostrandoFormulario(false);
    } catch (error) {
      console.error('Error al enviar pregunta:', error);
    }
  };

  const handleResponderPregunta = async (preguntaId) => {
    if (!nuevaRespuesta.trim() || !onResponderPregunta) return;

    try {
      console.log("Procesando respuesta para ID:", preguntaId);

      // 1. Mapear el array actual para inyectar la respuesta en la pregunta correcta
      const listaActualizada = preguntas.map((pregunta) => {
        if (pregunta.id === preguntaId) {
          console.log("✏️ Modificando pregunta:", pregunta);
          
          return {
            ...pregunta, // Mantiene datos originales (id, pregunta, fecha, tutor)
            respuesta: nuevaRespuesta,
            fechaRespuesta: new Date(),
            respondidoPor: nombreAsesor || 'Asesor',
          };
        }
        return pregunta; // Retorna las demás sin cambios
      });

      console.log("📝 Lista final a enviar al padre:", listaActualizada);

      // 2. Enviar la lista completa y modificada al padre
      await onResponderPregunta(listaActualizada);
      
      // Limpieza UI
      setNuevaRespuesta('');
      setRespondiendo(null);
    } catch (error) {
      console.error('Error al responder pregunta desde el componente:', error);
    }
  };

  //eliminar pregunta y respuesta
  const handleDeletePregunta = async() =>{

  }

  //editar pregunta
  const editarPregunta = async() =>{

  }

  const cancelarRespuesta = () => {
    setRespondiendo(null);
    setNuevaRespuesta('');
  };

  const cancelarPregunta = () => {
    setMostrandoFormulario(false);
    setNuevaPregunta('');
  };

  //guardar contenido con enriquecido
  const handleSaveContenido = (nuevoContenido) =>{
    try{
      setFormData(prev => ({
        ...prev,
        contenidoEnriquecido: nuevoContenido
      }));
    }
    catch(error){
      console.error('Error al guardar contenido:', error);
      throw error;
    }
  }

  const handleContenidoChange = (editorState) => {

  }

  return (
    <div className="space-y-6">
      {/* Header con estadísticas */}
      <div className="flex justify-between items-center">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">Preguntas y Respuestas - v2.0</h3>
          <p className="text-sm text-gray-600 mt-1">
            {preguntasFiltradas.length} pregunta{preguntasFiltradas.length !== 1 ? 's' : ''}
          </p>
        </div>
        
        <div className="flex items-center gap-3">
          <span className="text-sm text-blue-600 font-medium">
            {preguntasFiltradas.length} preguntas
          </span>
          {onEnviarPregunta  && !isAdmin && (
            <button
              onClick={() => setMostrandoFormulario(!mostrandoFormulario)}
              className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 flex items-center gap-2 transition-colors"
            >
              <Plus size={16} />
              Hacer una pregunta
            </button>
          )}
        </div>
      </div>

      {/* Formulario para nueva pregunta */}
      {mostrandoFormulario && onEnviarPregunta && (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">

          <ContenidoEnriquecido 
            contenido={formData.contenidoEnriquecido} 
            isAdmin={true}
            editable={true}
            onSave={handleSaveContenido}
            onChange={handleContenidoChange}
          />

          {/* Botones */}

          <div className="flex gap-2">
                <button
                  onClick={cancelarPregunta}
                  className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
                >
                  Cancelar
                </button>
                <button
                  onClick={handleEnviarPregunta}
                  disabled={!formData.contenidoEnriquecido}
                  className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center gap-2 transition-colors"
                >
                  <Send size={16} />
                  Enviar Pregunta
                </button>
          </div>
          


        </div>
        
      )}

      {/* Lista de preguntas */}
      <div className="space-y-4">
        {preguntasFiltradas.length > 0 ? (
          preguntasFiltradas.map((pregunta, index) => (
            <div key={pregunta.id || index} className="bg-white border border-gray-200 rounded-lg overflow-hidden">
              {/* Pregunta */}
              <div className="p-4">
                <div className="flex items-start gap-3">

                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-blue-600 font-medium text-sm">
                      {pregunta.nombreTutor?.charAt(0)?.toUpperCase() || 'U'}
                    </span>
                  </div>
                  
                  <div className="flex-grow min-w-0">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="font-medium text-gray-900">{pregunta.nombreTutor}</span>
                      <span className="text-xs text-gray-500">
                        {formatearFechaCompleta(pregunta.fechaPregunta)}
                      </span>
                      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                        Pregunta
                      </span>
                    </div>
                    

                    <ContenidoEnriquecido 
                      contenido={pregunta.pregunta} 
                      isAdmin={false}
                      editable={false}
                    />

                  </div>
                </div>
              </div>

              {/* Respuesta existente */}
              {pregunta.respuesta.length != 0 && (
                <div className="bg-green-50 border-t border-green-200 p-4">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <CheckCircle size={16} className="text-green-600" />
                    </div>
                    
                    <div className="flex-grow min-w-0">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="font-medium text-green-900">
                          Respuesta del Administrador
                        </span>
                        <span className="text-xs text-green-600">
                          {formatearFechaCompleta(pregunta.fechaRespuesta)}
                        </span>
                      </div>
                      
                      <ContenidoEnriquecido 
                        contenido={pregunta.respuesta} 
                        isAdmin={false}
                        editable={false}
                      />
                      
                      {pregunta.nombreAsesor && (
                        <p className="text-xs text-green-600 mt-2">
                          Respondido por: {pregunta.nombreAsesor}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Formulario para responder - SOLO para administradores */}
              {pregunta.respuesta.length == 0 && isAdmin && onResponderPregunta && (
                <div className="border-t border-gray-200 p-4">
                  {respondiendo === pregunta.id ? (
                    <div className="space-y-3">
                      <textarea
                        value={nuevaRespuesta}
                        onChange={(e) => setNuevaRespuesta(e.target.value)}
                        className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-green-500 resize-none"
                        rows="3"
                        placeholder="Escribe tu respuesta..."
                      />
                      
                      <div className="flex justify-end gap-2">
                        <button
                          onClick={cancelarRespuesta}
                          className="px-3 py-1.5 text-gray-600 hover:text-gray-800 text-sm transition-colors"
                        >
                          Cancelar
                        </button>
                        <button
                          onClick={() => handleResponderPregunta(pregunta.id)}
                          disabled={!nuevaRespuesta.trim()}
                          className="bg-green-600 text-white px-4 py-1.5 rounded-md hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-sm flex items-center gap-2 transition-colors"
                        >
                          <Send size={14} />
                          Responder
                        </button>
                      </div>
                    </div>
                  ) : (
                    <button
                      onClick={() => setRespondiendo(pregunta.id)}
                      className="text-green-600 hover:text-green-700 text-sm font-medium flex items-center gap-2 transition-colors"
                    >
                      <MessageSquare size={14} />
                      Responder pregunta
                    </button>
                  )}
                </div>
              )}

              {/* Estado sin respuesta */}
              {pregunta.respuesta.length == 0 && (
                <div className="border-t border-orange-200 bg-orange-50 p-3">
                  <div className="flex items-center gap-2">
                    <Clock size={14} className="text-orange-600" />
                    <span className="text-sm text-orange-700 font-medium">
                      {isAdmin ? 'Pregunta pendiente de respuesta' : 'Esperando respuesta...'}
                    </span>
                  </div>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="text-center py-12 bg-gray-50 rounded-lg">
            <div className="mx-auto w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mb-4">
              <MessageSquare size={24} className="text-gray-400" />
            </div>
            <h3 className="text-sm font-medium text-gray-900 mb-2">
              No hay preguntas aún
            </h3>
            <p className="text-sm text-gray-500 mb-4">
              {onEnviarPregunta 
                ? "Haz la primera pregunta para clarificar detalles del trabajo"
                : "No se han realizado preguntas para esta solicitud"
              }
            </p>
            {onEnviarPregunta && !isAdmin && (
              <button
                onClick={() => setMostrandoFormulario(true)}
                className="inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 transition-colors"
              >
                <Plus size={16} className="mr-2" />
                Hacer una pregunta
              </button>
            )}
          </div>
        )}
      </div>

    </div>
  );

};

export default PreguntasComponent;